<template>
  <v-select
    id="grupos-select"
    v-model="filter.grupoId"
    item-text="nome"
    item-name="usuarioGrupoId"
    item-value="usuarioGrupoId"
    :items="grupos"
    :label="placeholderName || 'Grupo'"
    :placeholder="placeholderName || 'Grupo'"
    clearable
    v-on:change="$emit('onChange')"
    :multiple="isMultiple ? true : false"
    :return-object="isMultiple ? true : false"
  >
    <template slot="no-data"> Nenhum Grupo retornado </template>
  </v-select>
</template>

<script>
import { groupAPI } from "../GroupAPI";
import { mapGetters } from "vuex";

export default {
  name: "AppUserGroupCombobox",
  props: ["filter", "isMultiple", "placeholderName", "idsToFilter"],
  mounted() {
    this.loadGroups();
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
  methods: {
    loadGroups() {
      groupAPI
        .list()
        .then((resp) => {
          this.grupos = resp.data;
        })
        .catch();
    },
  },
  watch: {
    idsToFilter: {
      handler(val) {
        if (!this.isFullAdmin) {
          this.grupos = this.grupos.filter((gp) =>
            val.some((ids) => gp.usuarioGrupoId === ids.usuarioGrupoId)
          );
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      grupos: [],
    };
  },
};
</script>
